var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 88,
    viewBox: "0 0 80 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_18_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 47.8954C0 25.8618 17.9664 8 40 8V8C62.0336 8 80 25.8618 80 47.8954V47.8954C80 69.929 62.0336 87.7908 40 87.7908V87.7908C17.9664 87.7908 0 69.929 0 47.8954V47.8954Z",
    fill: "url(#paint0_radial_18_321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 87.2908C18.2408 87.2908 0.5 69.6512 0.5 47.8954C0.5 26.1396 18.2408 8.5 40 8.5C61.7592 8.5 79.5 26.1396 79.5 47.8954C79.5 69.6512 61.7592 87.2908 40 87.2908Z",
    stroke: "url(#paint1_radial_18_321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 87.2908C18.2408 87.2908 0.5 69.6512 0.5 47.8954C0.5 26.1396 18.2408 8.5 40 8.5C61.7592 8.5 79.5 26.1396 79.5 47.8954C79.5 69.6512 61.7592 87.2908 40 87.2908Z",
    stroke: "url(#paint2_radial_18_321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 87.2908C18.2408 87.2908 0.5 69.6512 0.5 47.8954C0.5 26.1396 18.2408 8.5 40 8.5C61.7592 8.5 79.5 26.1396 79.5 47.8954C79.5 69.6512 61.7592 87.2908 40 87.2908Z",
    stroke: "url(#paint3_radial_18_321)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_18_321)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.7435,
    cy: 29.4822,
    rx: 25.3846,
    ry: 16.3673,
    fill: "url(#paint4_radial_18_321)",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9332 38.6666V34.9333C54.9332 32.8744 53.2589 31.2 51.1999 31.2H26.9333C23.8458 31.2 21.3333 33.7125 21.3333 36.8V59.1999C21.3333 63.3085 24.6821 64.7999 26.9333 64.7999H54.9332C56.9922 64.7999 58.6666 63.1255 58.6666 61.0666V42.4C58.6666 40.341 56.9922 38.6666 54.9332 38.6666ZM51.1999 55.4666H47.4666V48H51.1999V55.4666ZM26.9333 38.6666C26.4526 38.6451 25.9988 38.4391 25.6663 38.0913C25.3338 37.7436 25.1482 37.2811 25.1482 36.8C25.1482 36.3188 25.3338 35.8563 25.6663 35.5086C25.9988 35.1608 26.4526 34.9548 26.9333 34.9333H51.1999V38.6666H26.9333Z",
    fill: "url(#paint5_linear_18_321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_18_321",
    x: -5,
    y: 3,
    width: 90,
    height: 89.7908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18_321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_18_321",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18_321",
    x: 1.40435,
    y: 0.160334,
    width: 76.6784,
    height: 58.6438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.47727,
    result: "effect1_foregroundBlur_18_321"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.69204 8) rotate(47.9449) scale(119.431 86.7751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-42.5965 16.1628) rotate(35.0407) scale(92.1512 54.3882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_18_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.421 61.4008) rotate(161.385) scale(66.8428 45.1784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8470FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_18_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.871 -10.2359) rotate(47.2149) scale(44.643 32.0879)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_18_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7435 13.1149) rotate(90) scale(24.2566 37.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18_321",
    x1: 28.1388,
    y1: 81.2499,
    x2: 74.6098,
    y2: 41.0428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#DC8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#A9C4F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon);
export default __webpack_public_path__ + "static/media/manage_icon.e3fafe820762bcb72297e6c33fffaed3.svg";
export { ForwardRef as ReactComponent };